import { approvalTypeList } from '@/constants';
// import BASE_API from '@/api/dataBase';
export const searchColumns = (ctx) => {
  return [
    {
      prop: 'storageCode',
      name: '二级编码',
      type: 'input',
    },
    {
      prop: 'storageName',
      name: '二级名称',
      type: 'input',
    },
    // {
    //   prop: 'storageCompanyName',
    //   name: '所属组织',
    //   type: 'treeSelect',
    //   apiUrl: BASE_API.LIST_COMPANY_DEPT_TREE,
    //   apiData: {
    //     tenantCode: ctx.userInfo.tenantCode,
    //     adminFlag: ctx.userInfo.adminFlag,
    //     selfCompanyDepartmentTreeFlag: true,
    //   },
    // },
    {
      prop: 'belongToLevel1Id',
      name: '所属一级',
      type: 'searchTableSpec',
      searchType: 'storageTableDialog',
      isMultiple: true,
      changeMethod: ctx.changeStorageTableMethod,
      extraData: {
        level: 1,
        parentId: '',
      },
    },
    {
      prop: 'currentStatus',
      name: '状态',
      type: 'select',
      options: approvalTypeList.filter((item) => ['ZT03', 'ZT04'].includes(item.value)),
    },
    {
      name: '创建人',
      prop: 'storageCreatePersonNo',
      type: 'searchTableSpec',
      searchType: 'personnel',
      isMultiple: true,
      changeMethod: ctx.changeCreatePersonMethod,
    },
  ];
};

// 默认表头
export const defaultTableColumn = [
  {
    type: 'checkbox',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  // {
  //   type: 'seq',
  //   title: 'table.index',
  //   visible: true,
  //   width: '80',
  // },
  {
    field: 'storageCode',
    title: '二级编码',
    visible: true,
  },
  {
    field: 'storageName',
    title: '二级名称',
    visible: true,
  },
  {
    field: 'storageAddress',
    title: '仓库地址',
    visible: true,
  },
  {
    field: 'storageCompanyName',
    title: '所属组织',
    visible: true,
  },
  {
    field: 'belongToLevel1Name',
    title: '所属一级',
    visible: true,
  },
  {
    field: 'storageCreatePersonName',
    title: '创建人',
    visible: true,
  },
  {
    field: 'storageCreateTime',
    title: '创建时间',
    visible: true,
  },
  {
    field: 'currentStatus',
    title: '状态',
    visible: true,
  },
];
